import './App.css';
import {Navbar,Footer} from './components'
import {Home} from './pages'
import { Routes, Route } from "react-router-dom";
import HexaEyes from './pages/HexaEyes/HexaEyes';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import AboutUs from './pages/aboutus/about';
import PrivacyPolicy from './pages/privacy/privacy';
import TermsCondition from './pages/terms/terms';

const firebaseConfig = {
  apiKey: "AIzaSyA1OC6tkdTmwla07zIBvj6aOx1xj3k-mzs",
  authDomain: "kk-kreative-edition.firebaseapp.com",
  projectId: "kk-kreative-edition",
  storageBucket: "kk-kreative-edition.appspot.com",
  messagingSenderId: "400158214604",
  appId: "1:400158214604:web:526b8afa4b70b2d75fb569",
  measurementId: "G-7T30J70H9P"
};

function App() {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  return (
    <div>
      <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="HexaEyes" element={<HexaEyes />} />
            <Route path="AboutUs" element={<AboutUs />} />
            <Route path="PricacyPolicy" element={<PrivacyPolicy />} />
            <Route path="TermsCondition" element={<TermsCondition />} />
          </Routes>
      <Footer />
    </div>
  );
}

export default App;
